import { BaseRepository } from "@/repositories/base-repository.ts"
import type { IIncomingInvoice } from "@/interfaces/api/incoming-invoice.interface.ts"

export class IncomingInvoiceRepository extends BaseRepository<IIncomingInvoice> {
  protected resourcePath = "administration/incoming-invoices"
}
